import React from 'react';

export const NotificationsContext = React.createContext(null);
